import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { ApiClient } from "../api-client";
import { queryClient } from "../queryClient";

type AddSearchHistoryOptions = {
  phrase: string;
  lessonId: string;
};

export function useAddSearchHistory() {
  return useMutation({
    mutationFn: async (options: AddSearchHistoryOptions) => {
      const response = await ApiClient.api.opensearchControllerAddSearchHistory({
        phrase: options.phrase,
        lessonId: options.lessonId,
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["searchHistory"] });
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        console.error(error.response?.data.message);
      }

      console.error(error.message);
    },
  });
}
